import shop from "../shop/shop";
import * as types from "../constant/ActionType";

export const fssetchsogsinUser = (data) => ({
  type: types.FETCH_LOGIN_DATA,
  data,
});
export const fssetchsignupUser = (data) => ({
  type: types.FETCH_SIGNUP_DATA,
  data,
});
export const ForgetPasswordz = (data) => ({
  type: types.FORGET_PASSWORD,
  data,
});




export const specificroless = (data) => ({
  type: types.CREATE_ROLE,
  data,
});

export const Childassigpermissions = (data) => ({
  type: types.ASSIGN_PERMISSIONS,
  data,
});

export const childALLPermisssions = (data) => ({
  type: types.GETALL_PERMISSION,
  data,
});
export const rolePermissions = (data) => ({
  type: types.ROLE_PERMISSIONS,
  data,
});

export const contantAllviewroless = (data) => ({
  type: types.VIEW_ROLES,
  data,
});
export const viewOfAllUsers = (data) => ({
  type: types.VIEW_USERS,
  data,
});


// export const viewReportProblem = (data) => ({
//   type: types.VIEW_REPORT_PROBLEM,
//   data,
// });

// export const getNumberOfSerialsForBatch = (data) => ({
//   type: types.GET_SERIAL_FOR_BATCH,
//   data,
// });
// export const getBatchByProducts = (data) => ({
//   type: types.GET_BATCH_PRODUCT,
//   data,
// });

export const updateStatusUser = (data) => ({
  type: types.UPDATE_STATUS_USERS,
  data,
});



export const edituserChild = (data) => ({
  type: types.EDIT_USER,
  data,
});



export const allcount = (data) => ({
  type: types.All_COUNTS,
  data,
});


export const PostChangePassword = (data) => ({
  type: types.CHANGE_PASSWORD,
  data,
});


// <----------------- Property Type ---------------->

// <-------------------------Dashboard---------------------------------->

export const allDashboardsData = (data) => ({
  type: types.GET_ALL_DASHBOARD,
  data,
});
export const allChildassignper = (data) => ({
  type: types.ALL_ASSIGN_PERMISSIONS,
  data,
});

export const allDetailsAssignPremises = (data) => ({
  type: types.ALL_ASSIGN_PREMISES_DETAILS,
  data,
});
// <----------- Allproperty-------------------->

export const creatassignchildpermi = (data) => ({
  type: types.CREATE_ASSIGN_PERMISSION,
  data,
});

//  <------------------------- Payments ------------------------->



// <-------------------------- Users ------------------------>
export const createAddUsers = (data) => ({
  type: types.CREATE_ADD_USERS,
  data,
});
export const editUpdateUser = (data) => ({
  type: types.EDIT_UPDATE_USERS,
  data,
});
export const getAllUsers = (data) => ({
  type: types.GET_ALL_USERS,
  data,
});
export const getAllTenants = (data) => ({
  type: types.GET_ALL_TENANTS,
  data,
});
export const createAddTenant = (data) => ({
  type: types.CREATE_ADD_TENANTS,
  data,
});


export const updateEditTenant = (data) => ({
  type: types.CREATE_EDIT_TENANTS,
  data,
});
export const updateEditTenantStatus = (data) => ({
  type: types.CREATE_EDIT_TENANTS_STATUS,
  data,
});


// <-------------------------- Tenants ------------------------>

export const GetAllTenants = (data) => (dispatch) => {
  shop.GetAllTenants(data, (e) => {
    dispatch(getAllTenants(e, data));
  });
};
export const AddTenant = (data) => (dispatch) => {
  shop.AddTenant(data, (e) => {
    dispatch(createAddTenant(e, data));
  });
};
export const EditTenant = (data) => (dispatch) => {
  shop.EditTenant(data, (e) => {
    dispatch(updateEditTenant(e, data));
  });
};
export const EditTenantStatus = (data) => (dispatch) => {
  shop.EditTenantStatus(data, (e) => {
    dispatch(updateEditTenantStatus(e, data));
  });
};
// <-------------------------- Tenants ------------------------>


export const AllFetchAssignPermiss = (data) => (dispatch) => {
  shop.AllFetchAssignPermiss(data, (e) => {
    dispatch(allChildassignper(e, data));
  });
};

export const AllAssPreDetails = (data) => (dispatch) => {
  shop.AllAssPreDetails(data, (e) => {
    dispatch(allDetailsAssignPremises(e, data));
  });
};


export const CreateFetchAssignPermissiosn = (data) => (dispatch) => {
  shop.CreateFetchAssignPermissiosn(data, (e) => {
    dispatch(creatassignchildpermi(e, data));
  });
};

export const getAllDashboard = (data) => (dispatch) => {
  shop.getAllDashboard(data, (e) => {
    dispatch(allDashboardsData(e, data));
  });
};



export const CreateAddUsers = (data) => (dispatch) => {
  shop.CreateAddUsers(data, (e) => {
    dispatch(createAddUsers(e, data));
  });
};

export const EditUpdateUser = (data) => (dispatch) => {
  shop.EditUpdateUsers(data, (e) => {
    dispatch(editUpdateUser(e, data));
  });
};
export const GetAllUsers = (data) => (dispatch) => {
  shop.GetAllUsers(data, (e) => {
    dispatch(getAllUsers(e, data));
  });
};

export const fetchLoginUser = (data) => (dispatch) => {
  shop.fetchLoginUser(data, (e) => {
    dispatch(fssetchsogsinUser(e, data));
  });
};
export const fetchSignUpUser = (data) => (dispatch) => {
  shop.fetchSignUpUser(data, (e) => {
    dispatch(fssetchsignupUser(e, data));
  });
};
export const ForgetPassword = (data) => (dispatch) => {
  shop.ForgetPassword(data, (e) => {
    dispatch(ForgetPasswordz(e, data));
  });
};
export const VerifyOTP = (data) => (dispatch) => {
  shop.VerifyOTP(data, (e) => {
    dispatch(ForgetPasswordz(e, data));
  });
};

export const CreateFetchRolee = (data) => (dispatch) => {
  shop.CreateFetchRolee(data, (e) => {
    dispatch(specificroless(e, data));
  });
};
export const EditRole = (data) => (dispatch) => {
  shop.EditRole(data, (e) => {
    dispatch(specificroless(e, data));
  });
};

export const FetchAllUsersView = (data) => (dispatch) => {
  // const history=useHistory()
  shop.FetchAllUsersView(data, (e) => {
    dispatch(viewOfAllUsers(e, data));
  });
};

export const FetchUsersStatusUpdateView = (data) => (dispatch) => {
  shop.FetchUsersStatusUpdateView(data, (e) => {
    dispatch(updateStatusUser(e, data));
  });
};
export const FetchProductsStatusUpdateView = (data) => (dispatch) => {
  shop.FetchProductsStatusUpdateView(data, (e) => {
    dispatch(updateStatusUser(e, data));
  });
};


export const FetchAllRoleView = (data) => (dispatch) => {
  // const history=useHistory()
  shop.FetchAllRoleView(data, (e) => {
    dispatch(contantAllviewroless(e, data));
  });
};

export const AssignPermissionsShop = (data) => (dispatch) => {
  // const history=useHistory()
  shop.AssignPermissionsShop(data, (e) => {
    dispatch(Childassigpermissions(e, data));
  });
};

export const getAllPermissions = (data) => (dispatch) => {
  // const history=useHistory()
  shop.getAllPermissions(data, (e) => {
    dispatch(childALLPermisssions(e, data));
  });
};

export const GetRolePermissions = (data) => (dispatch) => {
  shop.GetRolePermissions(data, (e) => {
    dispatch(rolePermissions(e, data));
  });
};

export const HandleEditUserApi = (data) => (dispatch) => {
  // const history=useHistory()
  shop.HandleEditUserApi(data, (e) => {
    dispatch(edituserChild(e, data));
  });
};
export const HandleEditProductz = (data) => (dispatch) => {
  // const history=useHistory()
  shop.HandleEditProductz(data, (e) => {
    dispatch(edituserChild(e, data));
  });
};


export const AllCounts = (data) => (dispatch) => {
  // const history=useHistory()
  shop.GetAllCounts(data, (e) => {
    dispatch(allcount(e, data));
  });
};

export const AllTransactions = (data) => (dispatch) => {
  // const history=useHistory()
  shop.GetAllCounts(data, (e) => {
    dispatch(allcount(e, data));
  });
};


export const StatusUpdateBatches = (data) => (dispatch) => {
  // const history=useHistory()
  shop.StatusUpdateBatches(data, (e) => {});
};

export const HandleEditCompany = (data) => (dispatch) => {
  // const history=useHistory()
  shop.HandleEditCompany(data, (e) => {});
};


export const ChangePassword = (data) => (dispatch) => {
  shop.ChangePassword(data, (e) => {
    dispatch(PostChangePassword(e, data));
  });
};

// Recieved Qrcode Report
export const GetAllQrcodeReport = (data) => (dispatch) => {
  // const history=useHistory()
  shop.GetAllQrcodeReport(data, (e) => {
    // dispatch(viewAllQrcodeReport(e, data));
  });
};

